import { FunctionComponent, useCallback, useMemo } from 'react';
import { useSavedCourse } from '../../../../../../hooks/useSavedCourse';
import styles from './styles.module.scss';
import { HeartIcon } from '../../../../../Icons';
import actionButtonStyles from '../../styles.module.scss';
import classNames from 'classnames';
import { PublicCourse } from '@cademy-package/sdk-component-types';

export type SaveButtonProps = {
    courseId: PublicCourse['_id'];
    saved: boolean;
};

export const SaveButton: FunctionComponent<SaveButtonProps> = ({
    courseId,
    saved: initialSaved,
}) => {
    const { onSave, onUnsave, saved, loginModal } = useSavedCourse({
        courseId,
        saved: initialSaved,
    });
    const label = useMemo(() => (saved ? 'Unsave' : 'Save'), [saved]);

    const onButtonClick = useCallback(() => {
        if (saved === true) {
            return onUnsave();
        }
        return onSave();
    }, [onSave, onUnsave, saved]);

    return (
        <>
            <button
                className={classNames(actionButtonStyles.button, styles.saveButton)}
                onClick={onButtonClick}
                data-saved={saved}
            >
                <HeartIcon viewBox="-1 0 18 16" /> {label}
            </button>
            {loginModal}
        </>
    );
};
